const makePackagingInfoObj = (packagingInfoText) => {
  if (!packagingInfoText || typeof packagingInfoText !== 'string') {
    return [];
  }
  const packagingInfo = packagingInfoText.trim().split('\n').sort();
  const packagingInfoObj = [];
  packagingInfo.forEach(item => {
    const itemEq = item.split(' = ');
    packagingInfoObj.push({ name: itemEq[0], value: (itemEq[1] && itemEq[1].trim()) || 'unspecified' });
  });
  return packagingInfoObj;
}

export default makePackagingInfoObj;


// WEBPACK FOOTER //
// ./src/components/grids/PackagingInfoGrid/makePackagingInfoObj.jsx